import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MdErrorOutline } from 'react-icons/md';
import pandit from '../../assets/images/Fav.png';
export default function DailyPanditNoteModal({ isOpen, onClose, onSave }) {
    const [note, setNote] = useState('');

    const handleSave = () => {
        onSave(note);
        setNote('');
        onClose();
    };

    if (!isOpen) return null;

    return (
    <Modal
  show={isOpen}
  onHide={onClose}
  backdrop="static"
  keyboard={false}
  centered
  dialogClassName="custom-modal-width"
>
  <Modal.Header closeButton>
    <h5 className="text-center d-flex align-items-center gap-1 m-0">
      What is Daily Pandit Puja?
    </h5>
  </Modal.Header>

  <Modal.Body
    style={{
      position: "relative",
      overflow: "hidden",
      padding: "24px",
      
    }}
  >
    {/* Background Icon */}
    <div
  style={{
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${pandit})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "180px",
    opacity: 0.25,          // keep low & readable
    zIndex: 1,              // 👈 BACKGROUND
    pointerEvents: "none",
  }}
/>


    {/* Content */}
 <div
  style={{
    position: "relative",
    zIndex: 2,              // 👈 TEXT ALWAYS ABOVE
  }}
>
  <ul
    style={{
      paddingLeft: "18px",
      marginBottom: "16px",
      fontSize: "15px",
      lineHeight: "1.7",
      color: "#444",
      textAlign: "left",
    }}
  >
    <li>
      <strong>Daily Pandit Puja</strong> is a sacred ritual performed every
      day by an experienced and verified pandit on your behalf.
    </li>

    <li>
      The puja is conducted using proper
      <strong> Vedic mantras, sankalp, and traditional offerings</strong>
      as per Hindu scriptures.
    </li>

    <li>
      It helps invite <strong>peace, positivity, protection, and divine
      blessings</strong> into your daily life.
    </li>

    <li>
      This service is ideal for devotees who are unable to perform daily
      rituals themselves but wish to remain spiritually connected.
    </li>
  </ul>

  <div
    style={{
      padding: "10px 14px",
      fontSize: "14px",
      color: "#7a3e00",
    }}
  >
    🌼 Performed with devotion • As per Vedic traditions • Daily blessings
  </div>
</div>


  </Modal.Body>
</Modal>

    );
}